<template>
  <div class="ingress section white-bg">
    <span class="ingress__text" v-html="ingressText"></span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  ingressText: string;
}>();
</script>
